import {
  FundSheetModel,
  type ProjectModel,
  ReviewSheetModel,
  SegmentSheetModel,
} from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import type { z } from 'zod';
import { RsProjectInformation } from './RsProjectInformation';

type Props = z.infer<typeof ProjectModel> & {
  historySavedAt: string | undefined | null;
};

const parsedProps = (props) => {
  switch (props.sheetType) {
    case 'RS':
      return ReviewSheetModel.parse(props);
    case 'SS':
      return SegmentSheetModel.parse(props);
    case 'KS':
      return FundSheetModel.parse(props);
    default:
      return props;
  }
};

export const ProjectInformation: FC<Props> = (props) => {
  const projectData = {
    ...parsedProps(props),
    historySavedAt: props.historySavedAt,
  };
  return <RsProjectInformation {...projectData} />;
};
